/**
 * Human-readable label for a HostHub block `hold_reason`.
 *
 * `hold_reason` is an OPEN enum: known values map to a friendly label; anything
 * else falls back to the supplied `title`, then the raw `reason` (so unknown /
 * future reasons still render something meaningful). Shared by the daily digest,
 * the blocked-page calendar, and the read-only block dialog so the same block
 * reads identically on every surface.
 */
export function reasonLabel(reason: string | null | undefined, title?: string | null): string {
    switch (reason) {
        case "personal_use":
            return "Owner's visit";
        case "housekeeping":
            return "Housekeeping";
        default:
            return title || reason || "";
    }
}
